import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useQueryClient } from 'react-query';

import * as Constants from '../../../constants';
import { User } from '../../../@types';
import { Chat } from '../../chat/Chat';
import {
  useNewSonarGroupMessage,
  useSonarGroupMessages,
  SONAR_CACHE_KEYS,
} from '../../../api';

const SonarChatWrapper = styled.div`
  height: 400px;
  margin: 0;
`;
interface SonarChatProps {
  visible: boolean;
  user: User;
  group: any;
  canMessage: boolean;
  isModerator: boolean;
}
export const SonarChat: React.FC<SonarChatProps> = ({
  visible,
  user,
  group,
  canMessage,
  isModerator = false,
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync: submitMessage, isLoading } = useNewSonarGroupMessage(
    group.id
  );
  const {
    data: messages = [],
    isLoading: messagesLoading,
    isSuccess,
  } = useSonarGroupMessages(group.id);
  const onSendMessage = async (message: string) => {
    await submitMessage({
      group_id: group.id,
      user_id: user.id,
      message,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries(
        [SONAR_CACHE_KEYS.SONAR_GROUPS, group.episode_id],
        {
          refetchInactive: true,
        }
      );
    }
  }, [isLoading]);

  return (
    <SonarChatWrapper>
      <Chat
        onSubmit={onSendMessage}
        type="sonar"
        isVisible={visible}
        comments={messages.map((msg: any) => {
          return { ...msg, comment: msg.message };
        })}
        canMessage={canMessage}
        isLoading={isLoading || messagesLoading}
        isModerator={isModerator}
      />
    </SonarChatWrapper>
  );
};
